const productContent = document.getElementsByClassName(
  'product__content'
)[0];
const sprStarRating =
  document.getElementsByClassName('spr-starrating')[0];

if (!productContent && !sprStarRating) {
  if (productContent.classList.contains('text-center')) {
    sprStarRating.style.justifyContent = 'center';
  } else if (productContent.classList.contains('text-right')) {
    sprStarRating.style.justifyContent = 'flex-end';
  } else if (productContent.classList.contains('text-left')) {
    sprStarRating.style.justifyContent = 'flex-start';
  }
}

if (document.querySelector('.button-load-scroll') && document.querySelector('.section-complete-the-set')) {
  document.querySelector('.button-load-scroll').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.section-complete-the-set').scrollIntoView({ "behavior": "smooth"});

    let summaryElements = document.querySelectorAll('.section-complete-the-set summary');

    summaryElements.forEach(summaryElement => {
 
      if (summaryElement.querySelector('.drawer__button-text').textContent == 'Description'){
        summaryElement.click();
      }
    });

  })
}